export const jagodaGajewska = {
    'meta': {
        'title': 'Psychoterapeuta Jagoda Gajewska • Centrum COLLIGO',
        'description': 'Ukończyłam 5-letnie studia magisterskie z psychologii, o specjalności psychologia kliniczna, na Uniwersytecie SWPS we Wrocławiu.'
    },
    'url': {
        'address': '/torun/zespol/psychoterapeuta-jagoda-gajewska/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/jagoda-gajewska.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psychoterapeuta Jagoda Gajewska • Centrum COLLIGO w Toruniu'
        }
    }
}